import {
  Component,
  Input,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import zxcvbn from 'zxcvbn';

@Component ( {
  selector: 'reporter-password-strength',
  templateUrl: './password-strength.component.html',
  styleUrl: './password-strength.component.scss',
  standalone: false
} )
export class PasswordStrengthComponent implements OnChanges {
  @Input () password: string;
  strength: number | null = null;

  ngOnChanges ( changes: SimpleChanges ) {
    if ( changes[ 'password' ] ) {
      this.calculateStrength ();
    }
  }

  calculateStrength () {
    if ( !this.password ) {
      this.strength = null;
      return;
    }
    const result = zxcvbn ( this.password );
    this.strength = result.score; // 0 (weak) до 4 (strong)
  }

  getStrengthClass () {
    if ( this.strength === null ) return '';
    if ( this.strength <= 1 ) return 'weak';
    if ( this.strength === 2 ) return 'fair';
    if ( this.strength === 3 ) return 'good';
    return 'strong';
  }

}
